/**
 * Каноническая плитка метрики. Canon раздел 1.4: число ВСЕГДА ink-1
 * (text-fg-primary); семантический цвет — только строкой ПОД числом
 * (sub + subTone). Не красить value.
 */
import { STATUS_TONE_TEXT_CLASS } from "../../lib/statusTone";

export function StatTile({
  label,
  value,
  unit,
  sub,
  subTone = "muted",
  onClick,
  testId,
}: {
  label: string;
  value: string | number | null | undefined;
  unit?: string;
  /** семантическая строка под числом («в норме», «растёт», «риск») */
  sub?: string;
  subTone?: "muted" | "good" | "warn" | "bad";
  onClick?: () => void;
  testId?: string;
}) {
  // Цвет подписи — из единого статус-словаря (v212): те же классы, что
  // были в тернарнике, но источник один на все места.
  const subCls =
    STATUS_TONE_TEXT_CLASS[
      subTone === "good" ? "ok" : subTone === "warn" ? "warn" : subTone === "bad" ? "bad" : "muted"
    ];

  const body = (
    <>
      <div className="text-[10px] uppercase tracking-wider text-fg-muted">
        {label}
      </div>
      <div className="mt-1 text-lg font-semibold num-display text-fg-primary">
        {value ?? "—"}
        {unit && (
          <span className="text-sm text-fg-muted ml-1 font-normal">{unit}</span>
        )}
      </div>
      {sub && <div className={`text-[11px] mt-0.5 ${subCls}`}>{sub}</div>}
    </>
  );

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        data-testid={testId}
        className="indigo-card p-3 text-left w-full hover:bg-bg-raised/40 transition-colors"
      >
        {body}
      </button>
    );
  }
  return (
    <div data-testid={testId} className="indigo-card p-3">
      {body}
    </div>
  );
}
